import { Voorraad } from '../types/Voorraadbeheer';

import usePlankTableStore from './usePlankTableStore';

export default function useTooltipVoorraad<T extends Voorraad>() {
  const _showTooltip = usePlankTableStore((state) => state.showTooltip);
  const _updateTooltip = usePlankTableStore((state) => state.updateTooltip);
  const hideTooltip = usePlankTableStore((state) => state.hideTooltip);

  const showTooltip = (title: string, voorraad: T) => (event: React.MouseEvent) => {
    _showTooltip({
      title,
      aanwezig: voorraad.aanwezig,
      benodigd: voorraad.benodigd,
      nietInzetbaar: voorraad.nietInzetbaar,
      verwachtGereed: voorraad.verwachtGereed,
      overOfTekort: voorraad.overOfTekort,
      inzetten: voorraad.inzetten,
      claims: voorraad.claims,
      x: event.pageX,
      y: event.pageY,
      clientY: event.clientY,
      clientX: event.clientX,
    });
  };

  const updateTooltip = (title: string, voorraad: T) => (event: React.MouseEvent) => {
    _updateTooltip({
      title,
      aanwezig: voorraad.aanwezig,
      benodigd: voorraad.benodigd,
      nietInzetbaar: voorraad.nietInzetbaar,
      verwachtGereed: voorraad.verwachtGereed,
      overOfTekort: voorraad.overOfTekort,
      inzetten: voorraad.inzetten,
      claims: voorraad.claims,
      x: event.pageX,
      y: event.pageY,
      clientY: event.clientY,
      clientX: event.clientX,
    });
  };
  return { showTooltip, updateTooltip, hideTooltip };
}
